module.exports = __webpack_public_path__ + "static/img/team_honor_order_64.f7ae0435.png";